const salt = new TextEncoder().encode(process.env.REACT_APP_ENC_SALT);
const secret = process.env.REACT_APP_ENCRYPTION_KEY;
function bufferToBase64(buffer) {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)));
}

function base64ToBuffer(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
}

async function encrypt(text) {
  const encoder = new TextEncoder();
  const cleanText = text;

  const keyMaterial = await crypto.subtle.importKey(
    "raw",
    encoder.encode(secret),
    "PBKDF2",
    false,
    ["deriveKey"],
  );

  const key = await crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt,
      iterations: 100000,
      hash: "SHA-256",
    },
    keyMaterial,
    { name: "AES-GCM", length: 256 },
    false,
    ["encrypt"],
  );

  const iv = crypto.getRandomValues(new Uint8Array(12));
  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    encoder.encode(cleanText),
  );

  return {
    data: bufferToBase64(encrypted),
    iv: bufferToBase64(iv),
  };
}

async function decrypt(encryptedPayload) {
  const encoder = new TextEncoder();
  const decoder = new TextDecoder();

  const { data, iv } = encryptedPayload;

  // Import key material
  const keyMaterial = await crypto.subtle.importKey(
    "raw",
    encoder.encode(secret),
    "PBKDF2",
    false,
    ["deriveKey"],
  );

  // Derive same key (IMPORTANT: same salt & params)
  const key = await crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt,
      iterations: 100000,
      hash: "SHA-256",
    },
    keyMaterial,
    { name: "AES-GCM", length: 256 },
    false,
    ["decrypt"],
  );

  // Convert Base64 → ArrayBuffer
  const encryptedBuffer = base64ToBuffer(data);
  const ivBuffer = base64ToBuffer(iv);

  // Decrypt
  const decrypted = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv: new Uint8Array(ivBuffer) },
    key,
    encryptedBuffer,
  );

  return decoder.decode(decrypted);
}
export { encrypt, decrypt };
